import { api } from '@core/api/client'

const ROOT = '/api/modules/bcf'

type BcfAuditAction =
  | 'bcf.import'
  | 'bcf.close'
  | 'bcf.rename'
  | 'bcf.export'
  | 'bcf.topic.create'
  | 'bcf.topic.update'
  | 'bcf.topic.comment.add'
  | 'bcf.topic.comment.delete'
  | 'bcf.extensions.update'
  | 'bcf.topic.watchers.update'

export function bcfAudit(
  action: BcfAuditAction,
  metadata: Record<string, unknown> = {},
): void {
  api
    .post(`${ROOT}/audit`, { action, metadata })
    .catch(() => {
      // Fire-and-forget: audit is best-effort. Local-mode (no backend)
      // should not surface errors to the user mid-import.
    })
}
